import { cn } from '@/lib/utils'

interface WalletIconProps {
  className?: string
}

export function WalletIcon({ className }: WalletIconProps): React.ReactElement {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('size-6', className)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 4H17C17.7956 4 18.5587 4.31607 19.1213 4.87868C19.6839 5.44129 20 6.20435 20 7V17C20 17.7956 19.6839 18.5587 19.1213 19.1213C18.5587 19.6839 17.7956 20 17 20H5C4.20435 20 3.44129 19.6839 2.87868 19.1213C2.31607 18.5587 2 17.7956 2 17V7C2 6.20435 2.31607 5.44129 2.87868 4.87868C3.44129 4.31607 4.20435 4 5 4ZM4.46447 6.46447C4.60322 6.32572 4.79239 6.25 5 6.25H17C17.2076 6.25 17.3968 6.32572 17.5355 6.46447C17.6743 6.60322 17.75 6.79239 17.75 7V17C17.75 17.2076 17.6743 17.3968 17.5355 17.5355C17.3968 17.6743 17.2076 17.75 17 17.75H5C4.79239 17.75 4.60322 17.6743 4.46447 17.5355C4.32572 17.3968 4.25 17.2076 4.25 17V7C4.25 6.79239 4.32572 6.60322 4.46447 6.46447Z"
        fill="currentColor"
      />
      <path
        d="M16.75 9.75H20.5C21.0523 9.75 21.5 10.1977 21.5 10.75V13.25C21.5 13.8023 21.0523 14.25 20.5 14.25H16.75C15.5074 14.25 14.5 13.2426 14.5 12C14.5 10.7574 15.5074 9.75 16.75 9.75Z"
        fill="var(--color-primary)"
      />
    </svg>
  )
}
